import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeInUp, standardViewport } from '../../utils/animation';
import './ProcessHeader.scss';

const ProcessHeader = () => {
  const { t } = useTranslation('process');
  
  return (
    <section className="process-header">
      <motion.h1 
        className="process-header__title"
        initial="hidden"
        whileInView="visible"
        viewport={standardViewport}
        variants={fadeInUp}
      >
        {t('header.title')}
      </motion.h1>
    </section>
  );
};

export default ProcessHeader;
